import {Button, InputField} from '@elixir/components';
import {GetRequest} from '../../../common/service/GetRequest';
import './revisionDetail.scss';

import React from 'react';
import PropTypes from 'prop-types';

export default class RevisionDetail extends React.Component {

    static contextTypes = {
        translator: PropTypes.func.isRequired
    };

    constructor (props) {
        super(props);
        this.state = {
            revisionNumber: '',
            loaded: true
        };
    }

    componentDidMount () {
        const requestUrl = '/xml/revision_info.xml';
        const requestOptions = {isXml: true};

        new GetRequest(requestUrl, requestOptions).then(
            (result) => {
                const responseDoc = new DOMParser().parseFromString(result, 'application/xml');
                const revisionNumber = responseDoc.getElementsByTagName('revNumber')[ 0 ].textContent.trim();
                this.setState({revisionNumber: revisionNumber});
            }
        );
    }

    render () {
        const {
            revisionNumber
        } = this.state;

        return (<div className="revisionComponent">
            <div className="privacyStatement">{this.context.translator('revisionDetail.copyright')}</div>
        </div>);
    }
}

